
import {Route, Routes} from 'react-router-dom'
 import {PackageView} from './components/PackageView'
import {TalentsPublicView} from './components/TalentsPublicView'
import { PublicLayout } from './PublicLayout'
import ERoutes from '../../core/enums/ERoutes'

const PublicPage = () => (
  <Routes>
    <Route element={<PublicLayout />}>
      <Route path={ERoutes.PUBLIC_PACKAGES} element={<PackageView />} />
      <Route path={ERoutes.PUBLIC_TALENTS} element={<TalentsPublicView />} />
    </Route>
  </Routes>
)

export {PublicPage}
